{{ content }}
<ng-container *ngIf="needMore">
  <a *ngIf="!isContentToggled" (click)="toggleContent()">Show More</a>
  <a *ngIf="isContentToggled" (click)="toggleContent()">Show Less</a>
</ng-container>